import BreadCrumb from "../../../../components/breadcrumb";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { ProjectsData } from "../../../../components/tables/projects-tables/project";
import { useEffect, useState } from "react";
import { ProjectsType } from "../../../../data/types";
import { getAllProjects } from "../../../../API/Projects/projectsService";

const breadcrumbItems = [
  { title: "Travaux", link: "/admin-dashboard/travaux" },
];
export default function Projects() {
  const [projects, setProjects] = useState<ProjectsType[]>([]);
  const fetchData = async () => {
    const response = await getAllProjects();
    setProjects(response?.projects);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <ProjectsData data={projects} />
        </div>
      </div>
    </>
  );
}
